// extracted by mini-css-extract-plugin
export default {"link":"SidebarMember_link__jcKL4","linkIcon":"SidebarMember_linkIcon__yUqGA"};